import { Serializable } from "../core";
import { Category, GeneralCategory, SubCategory } from "./category";
import { Color } from "./color";
import { ProductAttribute } from "./product-attribute";

export class Product implements Serializable<Product> {
  id!: number;
  title!: string;
  description!: string;
  label?: string;
  attributes!: ProductAttribute[];
  images!: string[];
  generalCategory?: GeneralCategory;
  subCategory?: SubCategory;
  category?: Category;
  colors!: Color[];
  sizes!: string[];

  getFirstAvailableAttribute(): ProductAttribute {
    const sortedByPrice = this.attributes.sort((a, b) => {
      let aPrice = a.price;
      if (a.offPrice !== 0) aPrice = a.offPrice;
      let bPrice = b.price;
      if (b.offPrice !== 0) bPrice = b.offPrice;
      if (aPrice === bPrice) return 0;
      if (aPrice < bPrice) return -1;
      return 1;
    });
    const availableAttributes = sortedByPrice.filter(
      (attribute) => attribute.count !== 0
    );
    if (availableAttributes.length !== 0) return availableAttributes[0];
    return sortedByPrice[0];
  }

  hasLabel(): boolean {
    return this.label !== "" && this.label !== null && this.label !== undefined;
  }

  deserialize(json: any): Product {
    this.id = json.id;
    this.title = json.title;
    this.description = json.description;
    this.label = json.label;
    this.attributes = json.attributes.map((json: any) =>
      new ProductAttribute().deserialize(json)
    );
    this.colors = this.attributes
      .map((attribute) => attribute.color)
      .filter((color, index, self) => self.indexOf(color) === index);
    this.sizes = this.attributes
      .map((attribute) => attribute.size)
      .filter((size, index, self) => self.indexOf(size) === index)
      .sort();
    this.images = json.images
      .sort((a: any, b: any) => {
        if (a.index > b.index) return 1;
        if (a.index < b.index) return -1;
        return 0;
      })
      .map((json: any) => json.image);
    if (json.general_category !== null) {
      this.generalCategory = new GeneralCategory().deserialize(
        json.general_category,
        false
      );
      if (json.sub_category !== null) {
        this.subCategory = new SubCategory().deserialize(
          json.sub_category,
          false
        );
        if (json.category !== null)
          this.category = new Category().deserialize(json.category);
      }
    }
    return this;
  }
}
